import { Link } from "react-router-dom";
import { useLocale } from "../context/LocaleContext";
import { Mascot } from "../components/Mascot";
import { Button } from "../components/ui/button";

export default function NotFound() {
  const { t, lp } = useLocale();
  return (
    <div className="container-page flex min-h-[60vh] flex-col items-center justify-center text-center">
      <Mascot className="h-16 w-16" />
      <h1 className="mt-6 font-heading text-5xl font-black text-slate-900">404</h1>
      <p className="mt-2 text-slate-500">{t("notFound")}</p>
      <Button asChild className="mt-6 rounded-full bg-emerald-600 hover:bg-emerald-700">
        <Link to={lp("")}>{t("backHome")}</Link>
      </Button>
    </div>
  );
}
